import http from '../helpers/http-common';
import { ICrmbVwLeadCleanDTO, ICrmbVwLeadCustomDTO, ICrmbVwLeadFullDTO } from '../models/happy-code-api.model';
import { Predicate, formatHttpParams } from '../models/predicate.model';
import { baseCreate } from './base/base-create.service';
import { baseDelete } from './base/base-delete.service';
import { baseFindById } from './base/base-find-id.service';
import { baseFind } from './base/base-find.service';

export const useVwLeadService = () => {
	const resourceURL = 'crmb/vwlead';

	const findCustomIndex = (predicate: Predicate = new Predicate()) => {
		return http.get(`${resourceURL}/find-custom-index`, formatHttpParams(predicate))
	}


	const findCustomIndexById = (body) => {
		return http.get(`${resourceURL}/${body.id}/custom`)
	}

	return {
		...baseCreate<ICrmbVwLeadCleanDTO, ICrmbVwLeadCustomDTO, ICrmbVwLeadFullDTO>(
			resourceURL
		),
		...baseFindById<ICrmbVwLeadCleanDTO, ICrmbVwLeadCustomDTO, ICrmbVwLeadFullDTO>(
			resourceURL
		),
		...baseFind<ICrmbVwLeadCleanDTO, ICrmbVwLeadCustomDTO, ICrmbVwLeadFullDTO>(
			resourceURL
		),
		...baseDelete(resourceURL),
		findCustomIndex,
		findCustomIndexById,
	};
};
